export const mockDataFreetext = `Printable table of contents creator (1)
All entries are sorted by page number - earliest page ascending (3)
Non-headers are sorted under headers (2)
# Header looks like this (2,5)
Wrap tags with the pound sign #like this# (4)
# Printed layout leaves wider left margin for hole punching (5,10)
Entries can have multiple page ranges (6) (7,9)
`;
